import React from 'react';
import './FullPageLoader.css';

const FullPageLoader = () => {
    return (
        <div className="content-loader">
            <div className="loader"></div>
            <p>Loading, please wait...</p>
        </div>
    );
};

export default FullPageLoader;
